import { useCallback, useMemo } from "react";
import { useXAxisFormat } from "../../../hooks/useXAxisFormat";
import { KPI_CODES } from "../../../kpiCodes";
import dayjs from "../../../../../configs/dayjs";
import { useFetchDataForTwoLines } from "../../../hooks/useFetchDataForTwoLines";

export const useFetchData = (granularity: number, isRecalculated: boolean) => {
  const { xAxisFormat, tooltipFormat } = useXAxisFormat(granularity);

  const kpiCodes = useMemo(() => {
    if (granularity === 1) {
      return [KPI_CODES.VISITS_TODAY, KPI_CODES.VISITS_FIRST_TIME_TODAY];
    } else if (granularity === 2) {
      return [
        KPI_CODES.VISITS_THIS_MONTH,
        KPI_CODES.VISITS_FIRST_TIME_THIS_MONTH,
      ];
    }

    return [KPI_CODES.VISITS_THIS_YEAR, KPI_CODES.VISITS_FIRST_TIME_THIS_YEAR];
  }, [granularity]);

  const getFormattedItem = useCallback(
    (item: any, kpi: any) => {
      const type: string = item.code.split(".")[1];

      return {
        month: dayjs(kpi.createdAt).format(xAxisFormat),
        type:
          type !== "FirstTime" ? "All Unique Visitors" : "First-Time Visitors",
        value: kpi.value,
        tooltipValue: dayjs(kpi.createdAt).format(tooltipFormat),
        isMain: type !== "FirstTime",
      };
    },
    [tooltipFormat, xAxisFormat],
  );

  const { data, isLoading } = useFetchDataForTwoLines(
    granularity,
    isRecalculated,
    kpiCodes,
    getFormattedItem,
  );

  return { data, isLoading };
};
